import React from 'react'

import template from './cta-6.twig'

import parse from 'html-react-parser'

import {ButtonOptions, ContentOptions, HeadlineOptions, Offset} from '@miro-site/components_utils'

export interface Cta6Props {
  offset?: Offset
  headline: HeadlineOptions
  content?: ContentOptions
  button?: ButtonOptions
  additional_button?: ButtonOptions
  button_text?: ContentOptions
  children?: React.ReactNode
}

const Cta6 = (props: Cta6Props): React.ReactElement => {
  return (
    <>
      {parse(
        template({
          ...props,
          component_name: 'CTA Section',
          ctf_assets: 'images.ctfassets.net',
        }),
      )}
    </>
  )
}

export default Cta6
